import React, { useState } from 'react';
import Button from '../Button/Button';

const Header = () => {

    let Links = [
        {name:"HOME",link:"#home"},
        {name:"ABOUT",link:"#about"},
        {name:"SERVICE",link:"#service"},
        {name:"PORTFOLIO",link:"#portfolio"},
        {name:"BLOG'S",link:"/blog"},
        {name:"CONTACT",link:"#contact"},
    ]

    let [open, setOpen] = useState(false);
    return (
        <div className='shadow-md w-full fixed top-0 left-0 z-50'>
            <div className='md:flex items-center justify-between bg-[#0E1B31] py-4 md:px-10 px-7'>
                <div className='font-bold text-2xl cursor-pointer flex items-center text-white '>
                <span className='text-3xl text-white  mr-1 pt-2'>
                    <ion-icon name="code-slash-outline"></ion-icon>
                   
                </span>
                SHAHID
                </div>
                <div onClick={()=>setOpen(!open)} className='text-3xl absolute right-8 top-6 cursor-pointer md:hidden text-white'>
                <ion-icon name={open ? 'close':'menu'}></ion-icon>
                </div>
                <ul className={`md:flex md:items-center md:pb-0 pb-12 absolute md:static bg-[#0E1B31] md:z-auto z-[-1] left-0 w-full md:w-auto md:pl-0 pl-9 transition-all duration-500 ease-in ${open? 'top-20':'top-[-490px]'} md:opacity-100 opacity-0`}>
                    {
                        Links.map((link) => (
                            <li key={link.name} className="md:ml-8 text-lg md:my-0 my-7">
                                <a href={link.link} className="text-gray-400 hover:text-gray-200 duration-500">{link.name} </a>
                            </li>
                        ))
                    }
                    <a href="https://github.com/shahidul7150" target="_blank">
                    <Button>
                        <ion-icon name="logo-github"></ion-icon>
                       
                    </Button>
                   </a>
                </ul>
            </div>
      </div>
    );
};

export default Header;